import { createSelector, createFeatureSelector } from '@ngrx/store';
import { ILanguageState } from '../../interfaces/language/ILanguageState';

export const selectLanguageState =
  createFeatureSelector<ILanguageState>('language');

export const selectLanguage = createSelector(
  selectLanguageState,
  (state: ILanguageState) => state.language
);
